import fetch from '../fetch'
import { message } from 'antd';

const insert = (domain) => {
    return fetch.post('peer/review/insert' ,  domain)
    .then(res => {
        return res;
    })
}

const deleteFile = (ids) => {
    return fetch.post(`peer/review/file/delete` ,  ids);
}


export default {
    insert ,
    upload : `${fetch.base}peer/review/file` ,
    download: fetch.base + 'peer/review/file/download?id=',
    onlyDownload: fetch.base + 'peer/review/onlyDownload?id=',
    deleteFile 
}